// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"85":"2bde8ceb","562":"2bf313ed","594":"30f4661f","803":"ba1e8ce3"}[chunkId] + ".js";
};